import React, { useState } from 'react';
import {
  Box,
  Typography,
  Snackbar,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ShareCard from '../components/common/ShareCard';

const APP_LINK = 'https://smedco.co.zw/app';

const Share: React.FC = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState('');

  const handleCopy = () => {
    navigator.clipboard.writeText(APP_LINK);
    setSnackbarMsg('Link copied to clipboard');
    setSnackbarOpen(true);
  };

  const handleEmail = () => {
    window.open(`mailto:?subject=Try%20SMEDCO%20Mobile%20App&body=Download%20the%20app%20here:%20${encodeURIComponent(APP_LINK)}`);
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent('Try SMEDCO Mobile App: ' + APP_LINK)}`);
  };

  return (
    <Box sx={{ p: 3, maxWidth: 500, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>Share App</Typography>
      
      <ShareCard
        appLink={APP_LINK}
        onCopy={handleCopy}
        onWhatsApp={handleWhatsApp}
        onEmail={handleEmail}
      />
      
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2500}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMsg}
        action={
          <IconButton size="small" color="inherit" onClick={() => setSnackbarOpen(false)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </Box>
  );
};

export default Share; 